import { z } from 'zod';

const MAX_IMAGE_SIZE = 10 * 1024 * 1024; // 10MB
const ACCEPTED_IMAGE_TYPES = [
  // Image types
  "image/jpeg",
  "image/jpg",
  "image/png",
  "image/webp",
];

const generalRulesSchema = {
  general_discount: z
    .number()
    .min(0, { message: 'General discound must be 0 or more' }),
  increment: z
    .number()
    .int()
    .min(1, { message: 'increment must be 1 or more' }),
  min_qte: z.number().int().min(1, { message: 'Min qte must be 1 or more' }),
  max_qte: z.number().or(z.nan()).nullable().optional(),
};

export const step1Schema = z
  .object({
    name: z
      .string()
      .min(3, { message: 'Name must be at least 3 characters long' })
      .max(100, { message: 'Name must be at most 100 characters long' }),
    status: z.enum(['Draft', 'Approved', 'Inactive']),
    start_date: z.string().refine((val) => !isNaN(Date.parse(val)), {
      message: 'Invalid start date format',
    }),
    end_date: z
      .string()
      .refine((val: any) => !isNaN(Date.parse(val)), {
        message: 'Invalid end date format',
      })
      .nullable(),
    ...generalRulesSchema,
    image: z.instanceof(File).superRefine((file, ctx) => {
        if (!ACCEPTED_IMAGE_TYPES.includes(file.type)) {
          ctx.addIssue({
            code: z.ZodIssueCode.custom,
            message: "Invalid image type. Only .jpg, .jpeg, .png, .webp formats are supported.",
            params: { type: "invalid_type" },
          });
        }

        if (file.size > MAX_IMAGE_SIZE) {
          ctx.addIssue({
            code: z.ZodIssueCode.custom,
            message: "Each file must be less than 10MB.",
            params: { type: "too_large" },
          });
        }
      }).optional()
  })
  .refine(
    (data: any) => {
      if (data.end_date === null) return true;
      return new Date(data.end_date) >= new Date(data.start_date);
    },
    {
      message: 'End date must be later than or equal to start date',
      path: ['end_date'],
    }
  )
  .refine((data: any) => {
    const max = data.max_qte;
    const min = data.min_qte;

    // Only validate if max_qte is a number and not NaN
    if (typeof max !== 'number' || isNaN(max)) return true;

    return max > min;
  }, {
    message: 'Max qte must be greater than Min qte',
    path: ['max_qte'],
  });

export const step3Schema = z
  .object({
    products: z.array(z.object({
      discount: z.number()
      .min(0, { message: 'General discound must be 0 or more' }),
      min_qte: z.number().int().nullable().optional(),
      max_qte: z.number().int().nullable().optional(),
    })),
  })
